"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./controller/game"));
__export(require("./controller/multiplayer"));
__export(require("./controller/single-player"));
